<template>
    <div class="el-table-container templateBox">
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList(1)">
            <el-form-item prop="basicDataName" label="元数据模板名称：" v-show="navigation.length == 1">
                <el-input v-model.trim="searchForm.basicDataName" maxlength="50" placeholder="请输入元数据模板名称"
                          clearable></el-input>
            </el-form-item>
            <el-form-item prop="basicName" label="元数据名称：" v-show="navigation.length == 1">
                <el-input v-model.trim="searchForm.basicName" maxlength="50" placeholder="请输入元数据名称/别名"
                          clearable></el-input>
            </el-form-item>
            <el-form-item prop="basicRename" label="元数据名称：" v-show="navigation.length > 1">
                <el-input v-model.trim="searchForm.basicRename" maxlength="50" placeholder="请输入元数据名称/别名"
                          clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1)" size="small" icon="el-icon-search">查询</el-button>
                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="text_right p_all1">
            <el-button v-if="hasPermission('metadata:templateList:relevance') && navigation.length > 1 && !subTemplateFlag" type="primary"
                       size="small"
                       @click="relevance(null, 'add')">关联元数据
            </el-button>
            <el-button v-if="hasPermission('metadata:templateList:batchRelevance') && navigation.length == 2 && !subTemplateFlag"
                       type="primary" size="small"
                       @click="batchRelevance()">批量关联
            </el-button>
            <el-button v-if="hasPermission('metadata:templateList:add') && navigation.length == 1" type="primary"
                       size="small"
                       icon="el-icon-plus"
                       @click="addEdit(null, 'add')">新增模板
            </el-button>
            <el-button v-if="hasPermission('metadata:templateList:export') && navigation.length == 2" size="small"
                       @click="exportData()"><i class="icon-piliangdaochu iconfont buIcon"/>
                批量导出
            </el-button>
            <el-button v-if="hasPermission('metadata:templateList:del')" type="danger" size="small"
                       icon="el-icon-delete"
                       @click="del()">批量删除
            </el-button>
            <el-dropdown class="m_l1">
                <el-button type="primary" size="small">{{showList == 0 ? '卡片':'列表'}}<i
                        class="el-icon-arrow-down el-icon--right"></i></el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-show="showList == 1" @click.native="showList = 0">卡片</el-dropdown-item>
                    <el-dropdown-item v-show="showList == 0" @click.native="showList = 1">列表</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <div class="flex_l_c navigationBox">
            <img src="@/assets/img/templateIcon.png" class="templateIcon">
            <div v-for="(item, index) in navigation" :key="index" @click="selNavigation(item, index)">
                <el-link v-if="index == navigation.length-1" type="primary">{{item.basicDataName || item.basicRename}}</el-link>
                <el-link v-else>{{item.basicDataName || item.basicRename}}</el-link>
                <span class="arrows" v-if="index < navigation.length-1">></span>
            </div>
        </div>
        <!--模板-->
        <div class="dataBox" v-if="navigation.length == 1" v-loading="loading">
            <el-row class="cardBox" :gutter="10" v-show="showList == 0">
                <el-col class="m_b1 pointer" :span="6" v-for="(item, index) in dataList" :key="index">
                    <div class="el-card is-always-shadow">
                        <div class="flex_b_c p_all1">
                            <div class="omit flex_1 name"><img src="@/assets/img/templateIcon.png" class="templateIcon">{{item.basicDataName}}</div>
                            <el-checkbox class="m_l1" v-model="item.checked"
                                         @change="selectionChangeCheckbox(item)"></el-checkbox>
                        </div>
                        <div class="info" @click="searchTemplateData(item, 0)">
                            <div class="omit">可修改权限 {{item.basicDataAuthority == '0' ? '全馆' : item.basicDataAuthorityStrings}}</div>
                            <div>关联元数据数 {{item.basicAtomNumberCount + item.basicDimensionNumberCount}}条</div>
                            <div class="omit">简介：{{item.remark}}</div>
                        </div>
                        <div class="btnBox">
                            <el-link v-if="hasPermission('metadata:templateList:versions')" type="primary"
                                     @click.stop="versionManagement(item)">版本管理
                            </el-link>
                            <el-link v-if="hasPermission('metadata:templateList:business')" type="primary"
                                     @click.stop="associatedBusiness(item)">关联业务模板
                            </el-link>
                            <el-link v-if="hasPermission('metadata:templateList:comparison')" type="primary"
                                     @click.stop="modelComparison(item)">模型比对
                            </el-link>
                            <el-link v-if="hasPermission('metadata:templateList:examine')" type="primary"
                                     @click.stop="modelChecking(item)">模型检查
                            </el-link>
                            <el-link v-if="hasPermission('metadata:templateList:edit')" type="primary"
                                     @click.stop="addEdit(item, 'edit')">修改
                            </el-link>
                            <el-link v-if="hasPermission('metadata:templateList:del')" type="primary"
                                     @click.stop="del(item.id)">删除
                            </el-link>
                        </div>
                    </div>
                </el-col>
                <div class="noDataBox flex_1" v-if="!dataList.length">
                    <img src="@/assets/img/noData.png" class="noData">
                    <div>暂无数据</div>
                </div>
            </el-row>
            <el-table
                    :data="dataList"
                    @selection-change="selectionChangeHandle" @sort-change="sortChange"
                    size="small" height="100%"
                    class="table" ref="multipleTable" row-key='id' border v-show="showList == 1">
                <el-table-column fixed type="selection" :reserve-selection="true"></el-table-column>
                <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="basicDataName" label="名称" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        <el-link class="fontSize12" type="primary" @click="searchTemplateData(row, 0)">
                            {{row.basicDataName}}
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="basicDataName" label="类型" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        <span>元数据模板</span>
                    </template>
                </el-table-column>
                <el-table-column prop="basicDataAuthorityStrings" label="可修改权限" width="100"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column prop="remark" label="简介" show-overflow-tooltip></el-table-column>
                <el-table-column prop="basicDimensionNumberCount" label="元数据维度条目数" width="120"
                                 sortable show-overflow-tooltip></el-table-column>
                <el-table-column prop="basicAtomNumberCount" label="元数据原子条目数" width="120"
                                 sortable show-overflow-tooltip></el-table-column>
                <el-table-column prop="createDate" sortable label="创建时间" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createByUserName" label="创建人" show-overflow-tooltip></el-table-column>
                <el-table-column prop="updateDate" sortable label="最新修改时间" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="updateByUserName" label="最新修改人" width="100"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column fixed="right" width="320" label="操作">
                    <template slot-scope="{row}">
                        <el-button v-if="hasPermission('metadata:templateList:versions')" type="text" size="small"
                                   @click="versionManagement(row)">版本管理
                        </el-button>
                        <el-button v-if="hasPermission('metadata:templateList:business')" type="text" size="small"
                                   @click="associatedBusiness(row)">关联业务模板
                        </el-button>
                        <el-button v-if="hasPermission('metadata:templateList:comparison')" type="text" size="small"
                                   @click="modelComparison(row)">模型比对
                        </el-button>
                        <el-button v-if="hasPermission('metadata:templateList:examine')" type="text" size="small"
                                   @click="modelChecking(row)">模型检查
                        </el-button>
                        <el-button v-if="hasPermission('metadata:templateList:view')" type="text" size="small"
                                   @click="addEdit(row, 'view')">详情
                        </el-button>
                        <el-button v-if="hasPermission('metadata:templateList:edit')" type="text" size="small"
                                   @click="addEdit(row, 'edit')">修改
                        </el-button>
                        <el-button v-if="hasPermission('metadata:templateList:del')" type="text" size="small"
                                   @click="del(row.id)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--维度、原子-->
        <div class="dataBox atomBox" v-if="navigation.length > 1" v-loading="loading">
            <el-row class="cardBox" :gutter="10" v-show="showList == 0">
                <el-col class="m_b1 pointer" :span="6" v-for="(item, index) in dataList" :key="index">
                    <div :class="['el-card is-always-shadow', item.basicType == 1 ? 'cursor_default':'']">
                        <div class="flex_b_c p_all1">
                            <div class="omit flex_1 name"><img src="@/assets/img/dimensionalityIcon.png" class="templateIcon" v-if="item.basicType == 0"><img src="@/assets/img/atomIcon.png" class="templateIcon" v-else>{{item.basicRename}}</div>
                            <el-checkbox class="m_l1" v-model="item.checked"
                                         @change="selectionChangeCheckbox(item)"></el-checkbox>
                        </div>
                        <div @click="searchTemplateData(item)">
                            <div class="basicFor">
                                <el-tag size="mini" v-if="item.basicForAdd == 0">可新增</el-tag>
                                <el-tag size="mini" v-if="item.basicForEdit == 0">可编辑</el-tag>
                                <el-tag size="mini" v-if="item.basicForShow == 0">可查看</el-tag>
                            </div>
                            <div class="info">
                                <div class="omit">组件属性 <span v-if="item.basicRequired == 1">非</span>必填</div>
                                <div>组件类型 {{item.metadataBasicAssemblyName}}</div>
                            </div>
                        </div>
                        <div class="btnBox">
                            <el-link v-if="hasPermission('metadata:templateList:edit')" type="primary"
                                     @click.stop="relevance(item, 'edit')">修改
                            </el-link>
                            <el-link v-if="hasPermission('metadata:templateList:del')" type="primary"
                                     @click.stop="del(item.id)">删除
                            </el-link>
                        </div>
                    </div>
                </el-col>
                <div class="noDataBox flex_1" v-if="!dataList.length">
                    <img src="@/assets/img/noData.png" class="noData">
                    <div>暂无数据</div>
                </div>
            </el-row>
            <el-table
                    :data="dataList"
                    @selection-change="selectionChangeHandle" @sort-change="sortChange"
                    size="small" height="100%"
                    class="table" ref="multipleTable" row-key='id' border v-show="showList == 1">
                <el-table-column fixed type="selection" :reserve-selection="true"></el-table-column>
                <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="basicName" label="元数据名称" width="90" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        <span v-if="row.metadataBasicAssemblyName == '子模板' || row.metadataBasicAssemblyName == '子表单'">{{row.basicDataName}}</span>
                        <span v-else>{{row.basicName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="basicRename" label="别名" width="90" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        <span v-if="row.basicType == 1">{{row.basicRename}}</span>
                        <el-link class="fontSize12" type="primary" v-else @click="searchTemplateData(row)">{{row.basicRename}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="basicType" label="类型" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        {{$dictUtils.getDictLabel("basic_type", row.basicType ,'')}}
                    </template>
                </el-table-column>
                <el-table-column prop="metadataBasicAssemblyName" label="组件类型" show-overflow-tooltip></el-table-column>
                <el-table-column prop="basicForShow" label="组件权限" width="180" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        <el-tag size="mini" v-if="row.basicForAdd == 0">可新增</el-tag>
                        <el-tag size="mini" v-if="row.basicForEdit == 0">可编辑</el-tag>
                        <el-tag size="mini" v-if="row.basicForShow == 0">可查看</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="basicRequired" label="是否必填" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        {{$dictUtils.getDictLabel("public_state", row.basicRequired ,'')}}
                    </template>
                </el-table-column>
                <el-table-column prop="createDate" sortable label="关联时间" width="90" show-overflow-tooltip></el-table-column>
                <el-table-column prop="createByUserName" label="关联人" show-overflow-tooltip></el-table-column>
                <el-table-column prop="updateDate" sortable label="最新修改时间" width="100" show-overflow-tooltip></el-table-column>
                <el-table-column prop="updateByUserName" label="最新修改人" width="90" show-overflow-tooltip></el-table-column>
                <el-table-column fixed="right" width="140" label="操作">
                    <template slot-scope="{row}">
                        <el-button v-if="hasPermission('metadata:templateList:view')" type="text" size="small"
                                   @click="relevance(row, 'view')">详情
                        </el-button>
                        <el-button v-if="hasPermission('metadata:templateList:edit')" type="text" size="small"
                                   @click="relevance(row, 'edit')">修改
                        </el-button>
                        <el-button v-if="hasPermission('metadata:templateList:del')" type="text" size="small"
                                   @click="del(row.id)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <pagination v-if="total" :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
        <TemplateForm ref="templateForm" @refreshDataList="refreshList()"></TemplateForm>
        <VersionManagement ref="versionManagement"></VersionManagement>
        <ModelComparison ref="modelComparison"></ModelComparison>
        <ModelChecking ref="modelChecking"></ModelChecking>
        <Relevance ref="relevance" @refreshDataList="refreshList()"></Relevance>
        <BatchRelevance ref="batchRelevance" @refreshDataList="refreshList()"></BatchRelevance>
        <AssociatedBusiness ref="associatedBusiness" @refreshDataList="refreshList()"></AssociatedBusiness>
    </div>
</template>

<script>
    import TemplateForm from './templateForm'
    import VersionManagement from './versionManagement'
    import ModelComparison from './modelComparison'
    import ModelChecking from './modelChecking'
    import Relevance from './relevance'
    import BatchRelevance from './batchRelevance'
    import AssociatedBusiness from './associatedBusiness'

    export default {
        components: {
            AssociatedBusiness,
            TemplateForm,
            VersionManagement,
            ModelComparison,
            ModelChecking,
            Relevance,
            BatchRelevance,
        },
        data() {
            return {
                searchForm: {
                    basicName: '',
                    basicRename: '',
                    basicDataName: '',
                    basicDataId: '',
                    associationBasicId: '',
                    current: 1,
                    size: 20,
                    sortConfigs: [],
                },
                showList: '0',
                navigation: [
                    {
                        basicDataName: '元数据模板',
                        id: '',
                    }
                ],
                curNavigation: {},
                dataList: [],
                total: 0,
                dataListSelections: [],
                loading: false,
                subTemplateFlag: false, // 是否在子模板内
            }
        },
        mounted() {
            this.refreshList(1)
            this.curNavigation = this.navigation[0]
        },
        methods: {
            // 获取数据列表 current查第几页数据
            refreshList(type) {
                if (type == 1) {
                    this.searchForm.current = 1
                }
                let api = '', method = 'post'
                // 模板列表
                this.searchForm.basicDataId = ''
                this.searchForm.associationBasicId = ''
                this.searchForm.associationBasicDataId = ''
                if (this.navigation.length == 1) {
                    api = this.api.metadata.selectMetadataBasicDataList
                } else {
                    // 模板详情列表  associationBasicDataId子模板、子表单; associationBasicId标题
                    api = this.api.metadata.selectByBasicDataId
                    if(this.navigation.length == 2) {
                        this.searchForm.basicDataId = this.curNavigation.id
                    } else {
                        this.searchForm.basicDataId = this.navigation[1].id
                        if(this.curNavigation.basicAssemblyId == '19' || this.curNavigation.basicAssemblyId == '20') {
                            this.searchForm.associationBasicDataId = this.curNavigation.associationBasicDataId
                        } else if(this.curNavigation.basicAssemblyId == '18') {
                            this.searchForm.associationBasicId = this.curNavigation.id
                        }
                    }
                }
                this.loading = true
                this.$axios(api, this.searchForm, method).then(data => {
                    if (data && data.status) {
                        this.dataList = data.data.records
                        if (this.dataList.length == 0 && this.searchForm.current > 1) {
                            this.searchForm.current--
                            this.refreshList()
                        }
                        this.total = parseInt(data.data.total)
                        this.filterSelections()
                        this.loading = false
                    } else {
                        this.$message.error('查询失败')
                    }
                })
            },
            // 查询模板中的维度原子  type：0模板
            searchTemplateData(item, type) {
                if (item.basicType == 1) {
                    return
                }
                this.curNavigation = item
                this.navigation.push(item)
                if(type == 0) {
                    this.searchForm.basicDataId = item.id
                }
                this.filterSubTemplate()
            },
            // 点击导航栏
            selNavigation(item, index) {
                if (this.navigation.length == 1) {
                    return
                }
                this.curNavigation = item
                this.navigation = this.navigation.splice(0, index + 1)
                this.filterSubTemplate()
            },
            // 过滤是否有子模板
            filterSubTemplate() {
                this.dataListSelections = []
                this.$refs.searchForm.resetFields();
                let basicAssembly = this.navigation.filter(v => {return v.basicAssemblyId == '19' || v.basicAssemblyId == '20'})
                if(basicAssembly.length) {
                    this.subTemplateFlag = true
                } else {
                    this.subTemplateFlag = false
                }
                this.refreshList(1)
            },
            // 新增修改
            addEdit(data, method) {
                this.$refs.templateForm.init(data, method)
            },
            // 版本管理
            versionManagement(row) {
                this.$refs.versionManagement.init(row.id)
            },
            // 关联业务模板
            associatedBusiness(row) {
                this.$refs.associatedBusiness.init(row.id)
            },
            // 模型比对
            modelComparison(row) {
                this.$refs.modelComparison.init(row.id)
            },
            // 模型检查
            modelChecking(row) {
                this.$refs.modelChecking.init(row.id)
            },
            // 关联元数据
            relevance(item, method) {
                this.$refs.relevance.init(item, method, this.curNavigation)
            },
            // 批量关联
            batchRelevance() {
                this.$refs.batchRelevance.init(this.searchForm.basicDataId)
            },
            // 删除
            del(id) {
                let ids = [id];
                if (!id && !this.dataListSelections.length) {
                    this.$message.warning('请至少选择一条数据')
                    return
                }
                if (!id) {
                    ids = this.dataListSelections.map(item => {
                        return item.id
                    })
                }
                const h = this.$createElement;
                let type = this.navigation.length > 1 ? '确定删除所选项吗？' : '确认删除所选元数据模板？'
                let tips = this.navigation.length > 1 ? '' : h('p', {style: 'color: red; font-size: 12px'}, '元数据模板删除后，对应的录入数据将同步删除，且删除后不可恢复')
                this.$msgbox({
                    title: this.navigation.length > 1 ? '提示': '温馨提示',
                    message: h('p', null, [
                        h('p', {style: 'color: #000000; margin-bottom: 5px'}, type),
                        tips
                    ]),
                    showCancelButton: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {
                    this.loading = true
                    let api = this.api.metadata.batchDeleteMetadataBasicData
                    if (this.navigation.length > 1) {
                        api = this.api.metadata.batchDeleteMetadataBasicDataDetail
                    }
                    this.$axios(api, ids, 'post').then(data => {
                        if (data.status) {
                            this.$message.success('删除成功');
                        } else {
                            this.$message.error(data.msg);
                        }
                        this.refreshList()
                        this.$refs.multipleTable.clearSelection()
                        this.loading = false
                    })
                })
            },
            // 导入
            importData() {
                this.$refs.importData.init()
            },
            // 导出
            exportData() {
                if (!this.dataList.length) {
                    this.$message.warning('暂无可导出的数据！')
                    return
                }
                let idList = this.dataListSelections.map(item => {
                    return item.id
                })
                this.exportExcel(this.api.metadata.metadataBasicDataDetailExport, {
                    idList,
                    ...this.searchForm,
                }, this.curNavigation.basicDataName, 'post')
            },
            // 过滤多选
            filterSelections() {
                this.dataList.map(item => {
                    let len = this.dataListSelections.filter(v => v.id == item.id)
                    if (len.length) {
                        this.$set(item, 'checked', true)
                    } else {
                        this.$set(item, 'checked', false)
                    }
                })
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
                this.filterSelections()
            },
            // 列表排序
            sortChange(column) {
                this.searchForm.sortConfigs = [
                    {
                        fieldName: column.prop,
                        sortOrder: column.order == "descending" ? 'desc' : (column.order == "ascending" ? 'asc' : ''),
                    }
                ]
                this.refreshList()
            },
            // 多选框多选
            selectionChangeCheckbox(item) {
                let data = this.dataListSelections.filter(f => f.id == item.id)
                if (item.checked && !data.length) {
                    this.dataListSelections.push(item)
                    this.$refs.multipleTable.toggleRowSelection(item);
                } else {
                    this.dataListSelections = this.dataListSelections.filter(f => f.id != item.id)
                }
            },
            // 重置
            reset() {
                this.dataListSelections = []
                this.$refs.searchForm.resetFields();
                this.$refs.multipleTable.clearSelection()
                this.refreshList(1)
            }
        },
    }
</script>

<style scoped lang="scss">
</style>
